import { create } from 'zustand';

import { CreatePageType } from '@/types/create';
import { EmbedListItem } from '@/types/embed';

// 更新频率类型
type RefreshFrequency = 'weekly' | 'monthly';

interface CreateStoreState {
  pageType: CreatePageType;
  setPageType: (type: CreatePageType) => void;

  botId: string;
  setBotId: (id: string) => void;

  datasetId: string;
  setDatasetId: (id: string) => void;

  creating: boolean;
  toggle: () => void;
  startCreating: () => void;
  closeCreating: () => void;

  embedOpened: boolean;
  embedList: EmbedListItem[];
  toggleEmbedListOpened: () => void;
  setEmbedList: (list: EmbedListItem[]) => void;

  embeddingModelName: string;
  setEmbeddingModelName: (embeddingModelName: string) => void;

  datasetModelName: string;
  setDatasetModelName: (datasetModelName: string) => void;

  // Connector 更新频率设置
  refreshFrequency: RefreshFrequency;
  setRefreshFrequency: (frequency: RefreshFrequency) => void;

  refreshEnabled: boolean;
  setRefreshEnabled: (enabled: boolean) => void;

  advancedSettingsOpened: boolean;
  setAdvancedSettingsOpened: (opened: boolean) => void;
}

export const useCreateStore = create<CreateStoreState>((set, get) => ({
  pageType: 'create' as CreatePageType,
  setPageType: (type) => set({ pageType: type }),

  botId: '',
  setBotId: (id) => set({ botId: id }),

  datasetId: '',
  setDatasetId: (id) => set({ datasetId: id }),

  // creating
  creating: false,
  toggle: () =>
    set((state) => ({
      creating: !state.creating,
    })),
  startCreating: () => set({ creating: true }),
  closeCreating: () => set({ creating: false }),

  // embed
  embedOpened: false,
  embedList: [],
  toggleEmbedListOpened: () => set((state) => ({ embedOpened: !state.embedOpened })),
  setEmbedList: (list) => set({ embedList: list }),

  embeddingModelName: 'text-embedding-3-large',
  setEmbeddingModelName: (embeddingModelName) => set({ embeddingModelName }),

  datasetModelName: '',
  setDatasetModelName: (datasetModelName) => set({ datasetModelName }),

  // Connector 更新频率设置
  refreshFrequency: 'monthly',
  setRefreshFrequency: (frequency) => set({ refreshFrequency: frequency }),

  refreshEnabled: true,
  setRefreshEnabled: (enabled) => set({ refreshEnabled: enabled }),

  advancedSettingsOpened: false,
  setAdvancedSettingsOpened: (opened) => set({ advancedSettingsOpened: opened }),
}));
